import Big from "big.js";

/**
 * (B) リピート購入数量 = (A) x ([購入者購入数量]-1)
 * @param {Big} trialAfterCorrection (A)テスト品のトライアル購入数量(補正後)
 * @param {number} itemsPurchasedByPurchaser 購入者購入数量
 * @returns {number}
 */
export const calcRepeat = (trialAfterCorrection: Big, itemsPurchasedByPurchaser: number): Big => {
	return trialAfterCorrection.mul(new Big(itemsPurchasedByPurchaser).minus(1));
};
